import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Card, DropdownButton, Dropdown, Button } from "react-bootstrap";
import { Link, useLocation, useHistory } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import Loading from 'components/Loading';
import Icon from "components/Icons/Icon";
import CustomProgressBar from './CustomProgressBar';

import conxtdOut from 'apis/conxtdOut';
import Axios from '../../../../../node_modules/axios/index';

import { saveAs } from "file-saver";
import AddAssetCompany from './AddAssetCompany';

import { loadCompanyAssetsStart } from "services/redux/actions/serviceDesk";
import {
  getCompanyAssets,
  getCompanyAssetFields, 
  getSiteAssets 
} from 'services/redux/selectors/serviceDesk/assets';
import { getCompanyIdFromRoute } from 'services/redux/selectors/company';
import { loadSiteAssetsReset, setSiteAssetViewUid } from 'services/redux/actions/serviceDesk';
import { useIsMounted } from 'components/Common/CustomHooks/useIsMounted';

import BulkImportAssets from './CompanyAssetManager/AssetImportExport/BulkImportAssets';
import BulkDeleteAssets from './CompanyAssetManager/AssetImportExport/BulkDeleteAssets';

import AssetLogsWrapper from './CompanyAssetLogs/AssetLogsWrapper';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';

import ButterToast, { Cinnamon, POS_BOTTOM, POS_RIGHT} from 'butter-toast';
import { showFailedToast } from './CompanyAssetManager/AssetImportExport/Toasts/ImportLinkToasts/showFailedToast';
import { showSuccessfulToast } from './CompanyAssetManager/AssetImportExport/Toasts/ImportLinkToasts/showSuccessfulToast';
import { validateExcelBlob } from 'components/Common/Utils/validateExcelBlob';
import ExportCategory from './CompanyAssetManager/AssetImportExport/ExportCategory';
import { useWindowSize } from 'components/Common/CustomHooks/useWindowSize';
import CheckboxTableManual from 'components/Common/CheckboxTableManual/CheckboxTableManual';
import ActionBar from 'components/Common/ActionBar/ActionBar';
import DuplicateAssets from '../ActionBar/DuplicateAssets';
import UpdateFields from '../ActionBar/UpdateFields';
import _ from "lodash";
import debounce from "lodash/debounce";
import find from "lodash";

function DropdownItem ({ filterExport, filtersActive, totalAssets, totalAssetsUnfiltered, handleExport }) {

  const [assetCountExceeded, setAssetCountExceeded] = useState(true);
  const [unfilteredAssetCountInsuffient, setUnfilteredAssetCountInsufficient] = useState(true);
  const [assetCountInsuffient, setAssetCountInsufficient] = useState(true);
  const [disabledConditions, setDisabledConditions] = useState("");
  
  useEffect(() => {
    setAssetCountExceeded(filterExport ? 
      totalAssets > 200000
    :
      totalAssetsUnfiltered > 200000
    );

    // checks for empty data set for unfiltered and filtered results
    setUnfilteredAssetCountInsufficient(!totalAssetsUnfiltered);
    setAssetCountInsufficient(!totalAssets);
  }, [totalAssets, totalAssetsUnfiltered, filterExport])
  
  useEffect(() => {
    // conditions for when results are filtered
    if (filterExport) {
      setDisabledConditions(!filtersActive ?
        "No filters have been applied to the table" 
      : 
        assetCountExceeded ?
          "Exports are currently limited to 200,000 assets per export"
        : assetCountInsuffient ? "There are no filtered assets to export" : ""
      )
      // conditions for when results are not filtered
    } else {
      setDisabledConditions(assetCountExceeded ?
        "Exports are currently limited to 200,000 assets per export" : unfilteredAssetCountInsuffient ? "There are no assets to export" : ""
      )
    }
  }, [filtersActive, assetCountExceeded, assetCountInsuffient, filterExport, unfilteredAssetCountInsuffient])

  return (
    <>
      {disabledConditions ?
        <Tooltip
          description={disabledConditions}
          placement='right'
        >
          <Dropdown.Item
            data-intercom-target={`export-${filterExport ? "filtered" : "all"}-assets-button`}
            className={`${!disabledConditions ? '' : 'disabled-export'} export-assets-button`} 
            onClick={() => {return}}
          >
            <Icon className={`fas fa-${filterExport ? 'filter' : 'file-export'} dropdown-icon`} /> {filterExport ? "Export Filtered" : "Export All"}
          </Dropdown.Item>
        </Tooltip>
      :
        <Dropdown.Item
          data-intercom-target={`export-${filterExport ? "filtered" : "all"}-assets-button`}
          className={`${!disabledConditions ? '' : 'disabled-export'} export-assets-button`} 
          onClick={() => !disabledConditions ? handleExport({ filterExport }) : () => {return}}
        >
          <Icon className={`fas fa-${filterExport ? 'filter' : 'file-export'} dropdown-icon`} /> {filterExport ? "Export Filtered" : "Export All"}
        </Dropdown.Item>}
    </>
  )
}

function CompanyAssetsPage({ companyId, pagination, loadingCompanyAssets }) {

  const isMounted = useIsMounted();
  const windowSize = useWindowSize()
  const width = windowSize?.width ?? null;

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const loadingMsg = loadingCompanyAssets ? <Loading center /> : "No data available...";

  const darkMode = useSelector(state => state.app.darkMode);
  // const storeAssetId = useSelector(state => state.serviceDesk.assets.site.data.assetId);

  // const companyAssetsData = useSelector(getCompanyAssets);
  const companyAssetsDataOriginal = useSelector(getCompanyAssets);
  const companyAssetsFields = useSelector(getCompanyAssetFields);
  const siteAssetsData = useSelector(getSiteAssets);
  const exportFilters = useSelector(state => state.serviceDesk.assets.company.data.pagination?.filterQueryString)
  const filtersActive = useSelector(state => state.serviceDesk.assets.company.data.pagination?.filtersActive)
  const assetsCount = useSelector(state => state.serviceDesk.assets.company.data.pagination?.count);

  const [companyAssetsData, setCompanyAssetsData] = useState([]);
  
  useEffect(() => {
    const data = {...companyAssetsDataOriginal};

    let datatWithId = Object?.values(data)?.map(i => {
      return {
        ...i,
        id: i?.asset_details?.asset_uid ?? undefined,
      }
    });

    setCompanyAssetsData(datatWithId);
  }, [companyAssetsDataOriginal])

  const [rowData, setRowData] = useState(companyAssetsData);
  const [mappedColumns, setMappedColumns] = useState([]);
  const [defaultColumns, setDefaultColumns] = useState([]);
  const [columns, setColumns] = useState([]);
  const [assetFields, setAssetFields] = useState([]);
  const [companyDetails, setCompanyDetails] = useState({});
  const [extraFieldsAdded, setExtraFieldsAdded] = useState(false);
  const [totalAssetsUnfiltered, setTotalAssetsUnfiltered] = useState(null);
  const [totalAssets, setTotalAssets] = useState(0);
  
  const [categoriesList, setCategoriesList] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [categoryId, setCategoryId] = useState(null);
  
  // import/export/delete modals
  const [showImportModal, setShowImportModal] = useState(false);
  const [importIsUpdate, setImportIsUpdate] = useState(false);
  const [importIsCategory, setImportIsCategory] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  
  // progress-status states
  const [showExportStatus, setShowExportStatus] = useState(false);
  const [showImportStatus, setShowImportStatus] = useState(false);
  const [showDeleteStatus, setShowDeleteStatus] = useState(false);
  const [showAddSiteAssetModal, setShowAddSiteAssetModal] = useState(false);
  
  // checkbox table states
  const [selection, setSelection] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedCount, setSelectedCount] = useState(null);
  const [dataTableState, setDataTableState] = useState({});
  const [checkboxPagination, setCheckboxPagination] = useState({});

  // modal state
  const [showAssetFieldModal, setShowAssetFieldModal] = useState(false);
  const [showDuplicateAssetModal, setShowDuplicateAssetModal] = useState(false);

  const getDataTableState = (state) => {
    setDataTableState(state);
  }

  const formatDataTableStateParams = useCallback((state) => {

    if (!companyId || !state || Object.keys(state).length === 0) return;

    const limit = state.pageSize || 20;
    const page = state.requestPageNumber || 1;
    
    let paramString = "";
    state.filtered && state.filtered.forEach((filter) => {
      paramString = `${paramString}&${filter.id}=${filter.value}`
    });
    // state.externalFilters && state.externalFilters.forEach((externalFilter) => {
    //   paramString = `${paramString}&${externalFilter.id}=${externalFilter.value}`
    // });

    return `?limit=${limit}&page=${page}${paramString}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTableState, companyId])

  useEffect(() => {
    dataTableState && setCheckboxPagination((prev) => ({
      ...prev,
      select_all: selectAll,
      query_params: formatDataTableStateParams(dataTableState),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formatDataTableStateParams, dataTableState, selectAll])

  useEffect(() => {
    setSelectedCount(selectAll
      ? assetsCount - selection?.length
      : selection.length
    )
  }, [selection, assetsCount, selectAll])
  
  const toggleAll = () => {
    setSelectAll(!selectAll);
    setSelection([]);
  }

  const deselect = () => {
    setSelection([]);
    if (selectAll) {
      toggleAll();
    }
  };
  
  const handleDuplicateAssets = () => {
    return;
  }

  const handleModalShow = () => {
    setShowAddSiteAssetModal(true);
  }

  const handleModalClose = () => {
    setShowAddSiteAssetModal(false);
  }

  const categoriesListMemo = useMemo(() => categoriesList, [categoriesList]);

  useEffect(() => {
    setTotalAssets(assetsCount || 0);
    if (totalAssetsUnfiltered === null && assetsCount) {
      setTotalAssetsUnfiltered(assetsCount || 0);
    }
  }, [assetsCount, filtersActive, totalAssetsUnfiltered, companyAssetsData])

  useEffect(() => {
      const source = Axios.CancelToken.source();
      if (companyId && !loadingCompanyAssets) {
        const getAssetCategories = conxtdOut.get(`/company-assets/company-assets/${companyId}`, { cancelToken: source.token });
        getAssetCategories.then((res) => {
          const data = Array.isArray(res?.data) ? res?.data : [];
          setCategoriesList(data);
          setLoadingCategories(false);
        }).catch((error) => {
          console.log(error);
          setLoadingCategories(false);
        })
      }
  
      return () => {
        source.cancel("Component unmounted: request cancelled")
      }
    }, [companyId, showImportModal])

  const stringToSnakeCase = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, '$1_$2')
      .replace(/[\s\-]+/g, '_')
      .toLowerCase();
  }

  useEffect(() => {
    if (siteAssetsData.getSiteAssetsData.length > 0) {
      dispatch(loadSiteAssetsReset());
    }
  }, [siteAssetsData, dispatch])
  
  const columnsRef = useRef(columns);

  // use ref to ensure non-stale columns data provided 
  // to apply filter callback function
  useEffect(() => {
    columnsRef.current = columns;
  }, [columns]);

  const [tableFilters, setTableFilters] = useState([]);

  const applyTableFilter = useCallback((filterValue, filterColumnDetails) => {
    const currentColumns = columnsRef.current; // using a ref ensures columns are always up to date

    setTableFilters((prevTableFilters) => {
      const newTableFilters = currentColumns
        .map((column) => {
          const existingFilter = _.find(prevTableFilters, { id: column.id });

          if (column.id === filterColumnDetails.id) {
            return {
              id: column.id,
              value: filterValue,
              header: filterColumnDetails.Header,
              color: filterColumnDetails.filterTagColor
                ? filterColumnDetails.filterTagColor
                : "#191970",
            };
          } else if (existingFilter) {
            return existingFilter;
          } else {
            return { value: "" };
          }
        })
        .filter((item) => !!item.value);

      return newTableFilters;
    });
  }, []);

  // maps default asset fields into column-cell structure and saves to state
  useEffect(() => {
    if (companyId) {
      setMappedColumns(assetFields.map(item => {
        const string = item.toString();
    
        const header = (string) => {
          if (!string) return "";
          
          return string
            .split(" ")
            .map(word => word.charAt(0)?.toUpperCase() + word.slice(1)?.toLowerCase()) 
            .join(" ");
        };
    
        if (string === "Photo") {
          return {
            key: "PHOTO",
            Header: "Image",
            id: "photo",
            type: "image",
            filterable: false,
            // width: 200,
            accessor: data => {
              const url = data?.asset_values?.Photo?.file_url;
              return (
                url ?
                  <img className="company-asset-image" src={url} alt="site-asset" />
                :
                  <span className='ml-1'>{missingData()}</span>
              )
            },
          }
        }
    
        return {
          key: `${string.toUpperCase()}`,
          Header: `${header(string)}`,
          id: stringToSnakeCase(string),
          filterable: true,
          Filter: ({ column }) => {
            return <input
              type="text"
              id={`${column.id}_filter_input`}
              onChange={debounce((e) => {
                applyTableFilter(e.target.value ?? undefined, column);
              }, 300)}
            />
          },
          Cell: (props) => {
            const index = string;
            const site_id = props?.original?.site_details?.id;
            const asset_category = props.original?.asset_details?.asset_name;
            const asset_category_id = props.original?.asset_details?.asset_id;
            const asset_uid = props.original?.asset_details?.asset_uid;
            const updatedPath = location.pathname.replace(/\/assets(?:\/|$)/, '');
            const value = props.original?.asset_values?.[index]?.value;
            const type = props?.original?.asset_values?.[index]?.type;
            // optional colour value for dropdown fields to determine circle icon colour
            const colour = props?.original?.asset_values?.[index]?.colour ?? 'lightgray';
            return (
              <div className='data-table-cell hide-scrollbar'>
                {
                  index === 'Name' || index === 'name' ?
                    <Link 
                      data-intercom-target={"site-editor-link-data-table"} 
                      to={`${updatedPath}/${site_id}?sub-page=assets&category=${asset_category}&category-id=${asset_category_id}&name=${value}`}
                      onClick={() => dispatch(setSiteAssetViewUid(asset_uid))}
                    >
                      <Icon className="fas fa-external-link-square-alt mr-2 dropdown-icon"></Icon>
                      {value}
                    </Link>
                  :
                    // appends circle icon before text value if colour value is present
                    type === "dropdown" && colour && value ? 
                      <span className='d-flex align-items-center ml-1'>
                        <Icon style={{ color: colour ?? 'lightgray' }} className='fas fa-circle fa-xs mr-2' />
                        <span>{value}</span>
                      </span>
                  :
                    value ?? missingData()
                  }
              </div>
            )
          },
        }
      }))
    }
  }, [companyId, assetFields, dispatch, location.pathname])

  useEffect(() => {
    if (defaultColumns.length === 0) {
      setDefaultColumns(mappedColumns);
    }
  }, [mappedColumns, defaultColumns, setDefaultColumns])

  useEffect(() => {
    // checks that page has been changed and assures data isn't reverted to first page during refresh
    if (companyId) {
      if (companyAssetsFields.length > 0) {
        const mappedFieldNames = Object.values(companyAssetsFields).map(field => field?.field_name)
        setAssetFields(mappedFieldNames);
      // sets row data and ensures values are of type array and not object
      }
      setRowData(companyAssetsData)
    }
  }, [companyAssetsData, setAssetFields, setDefaultColumns, setRowData, companyAssetsFields, companyId])

  useEffect(() => {
    if (defaultColumns.length > 0) {
      setColumns(defaultColumns)
    }
  }, [setColumns, defaultColumns])
  
  const missingData = () => {
    return <span>N/A</span>
  }

  useEffect(() => {
    const source = Axios.CancelToken.source();

    if (companyId && isMounted) {
      const getCompanyDetails = conxtdOut.get(`/Authake/company/${companyId}`, { cancelToken: source.token });
      getCompanyDetails.then((response) => {
        setCompanyDetails({
          companyName: response.data.company.name,
          companyLogoURL: response.data.company.logo_url,
        })
      }).catch((error) => {
        console.log("Error on get company details", error);
      })

      // dispatch(loadCompanyAssetsStart({ companyId }));
    }

    return () => {
      source.cancel("Component unmounted: request cancelled")
    }
  }, [companyId, dispatch])

  useEffect(() => {
    if (defaultColumns.length > 0) {
        const extraFields = [
          {
            key: "SITE_REF",
            Header: "Site Ref",
            id: "site_ref",
            filterable: true,
            Filter: ({ column }) => {
              return <input
                type="text"
                id={`${column.id}_filter_input`}
                onChange={debounce((e) => {
                  applyTableFilter(e.target.value, column);
                }, 300)}
              />
            },
            // width: 200,
            Cell: (props) => {
              const site_ref = props?.original?.site_details?.site_ref;
              return (
                <div className='data-table-cell hide-scrollbar'>
                  {site_ref ?
                    <div>
                      {site_ref}
                    </div>
                  :
                    missingData()
                  }
                </div>
              )
            },
          },
          {
            key: "SITE_NAME",
            Header: "Site Name",
            id: "site_name",
            filterable: true,
            Filter: ({ column }) => {
              return <input
                type="text"
                id={`${column.id}_filter_input`}
                onChange={debounce((e) => {
                  applyTableFilter(e.target.value, column);
                }, 300)}
              />
            },
            Cell: (props) => {
              const site_name = props?.original?.site_details?.site_name;
              return (
                <div className='data-table-cell hide-scrollbar'>
                  {
                    site_name
                  ??
                    missingData()
                  }
                </div>
              )
            },
          },
          {
            key: "ASSET_CATEGORY",
            Header: "Asset Category",
            id: "asset_category",
            filterable: true,
            Filter: ({ column }) => {
              return <input
                type="text"
                id={`${column.id}_filter_input`}
                onChange={debounce((e) => {
                  applyTableFilter(e.target.value, column);
                }, 300)}
              />
            },
            // width: 200,
            Cell: (props) => {
              const asset_category = props?.original?.asset_details?.asset_name;
              return (
                <div className='data-table-cell hide-scrollbar'>
                  {asset_category ?
                    <div>
                      {asset_category}
                    </div>
                  :
                    missingData()
                  }
                </div>
              )
            },
          },
        ]
    
        if (!extraFieldsAdded) {
          setColumns(prevColumns => [
            ...prevColumns.slice(0, 1),
            ...extraFields,
            ...prevColumns.slice(1),
          ]);
        }
        setExtraFieldsAdded(true);
    }
  }, [companyAssetsFields, companyAssetsData, defaultColumns, setColumns, extraFieldsAdded, setExtraFieldsAdded, location.pathname])
  
    // successful toast function ------------------>
    const submittingToast = (text) => {

      return ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="File submitted"
            content={
              <div className='toast-assets'>
                <span className='toast-info'>
                  {text}
                </span>
              </div>
            }
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
          />
        ),
        sticky: true,
      });
    }
    // ------------------|

  // function to export assets, either filtersActive or entire list depending on value of boolean filtered argument
  const handleExport = ({ filterExport = false, categoryExport = false }) => {

    const getExport = categoryExport ? 
    // export for category
      conxtdOut.get(`/company-assets-bulk/export/${categoryId}`, { responseType:'arraybuffer' })
    :
    // export for filtered or all
      conxtdOut.get(`/company-assets-bulk/export-filtered/${companyId}${filterExport ? `/?${exportFilters}` : ""}`,
      {
        responseType:'arraybuffer',
      }
    );

    setShowExportStatus(true);
    submittingToast("Exporting file...");

    const exportFileName = companyDetails?.companyName + ".xlsx";

    getExport.then(async (response) => {
      const contentType = response.headers['content-type'];
      const isExcel = contentType?.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

      let blob = null;

      if (isExcel) {
        blob = new Blob([response.data], { type: contentType });
      }

      setShowExportStatus(false);

      const isValid = blob !== null ? await validateExcelBlob(blob) : false;

      if (!isValid || blob === null || blob.size === 135) {
        showSuccessfulToast({
          fileName: exportFileName,
          title: "File Received Successfully",
          scheme: "SCHEME_GREEN",
          message: "You will receive an email with the results of this export",
          large: true,
          showLink: true,
          history,
          companyId,
        });
      } else {
        if (blob !== null && isValid && exportFileName) {
          saveAs(blob, exportFileName);
        }
        showSuccessfulToast({
          fileName: exportFileName,
          title: "File Received Successfully",
          scheme: "SCHEME_GREEN",
          message: "You can download this file and will receive an email with the results of the export shortly",
          large: true,
          showLink: true,
          history,
          companyId,
        });
      }

    }).catch((error) => {
      console.log("error", error?.message);
      const message = error?.message ?? "An error was encountered when retrieving the file";
        showFailedToast({
          fileName: exportFileName,
          title: "Failed To Receive File",
          scheme: "SCHEME_RED",
          message: message ? message : "",
          large: true,
          history,
          companyId,
        });
        setShowExportStatus(false);
    })
  }

  const triggerDispatch = useCallback(() => {
    dispatch(
      loadCompanyAssetsStart({ 
        companyId: companyId, 
        requestPageNumber: checkboxPagination?.requestPageNumber ?? 1,
        pageSize: checkboxPagination?.pageSize ?? 100,
        filters: tableFilters ?? [],
        // externalFilters: externalFilters,
      })
    );
  }, [dispatch, companyId, checkboxPagination, tableFilters, loadCompanyAssetsStart]);

  return (
    <div className={`${darkMode ? "darkMode" : ""}`}>
      <div id="company-assets-page">
        <Card className="card-wrapper">
        <header id="company-assets-page-header" className="d-flex align-items-center justify-content-between flex-column w-100">
          {/* Row 1 */}
          <div className='d-flex flex-row align-items-center justify-content-between w-100'>
            <Link
              to={`/companies/company/${companyId}`} 
              className="back-to-sd d-flex align-items-center"
            >
              <Icon className="fas fa-chevron-left mr-2 dropdown-icon" />
              <p className="m-0">Back to Service Desk</p>
            </Link>

            <span id="company-assets-page-title">
              {loadingCompanyAssets ? <Loading /> : <span>Assets</span>}
            </span>

            <div className="d-flex flex-column align-items-end position-relative mr-2">
              <span id="editor-site-name">{companyDetails?.companyName}</span>
              <span className="total-assets">{/* stacked underneath */}
                Total Assets: {totalAssets}
              </span>
            </div>
          </div>
        </header>

        <div id="dropdown-menu-contents" className='d-flex flex-start flex-row flex-nowrap align-items-bottom mb-2'>
          
          {/* Logs */}
          <div>
            <CustomProgressBar show={false} styling='mb-1'/>
            <AssetLogsWrapper companyId={companyId} />
          </div>

          {/* Import */}
          <div>
            <CustomProgressBar show={showImportStatus} styling='mb-1' />
            <DropdownButton title="Add" className="mr-1 dropdown-label">
              <Dropdown.Item 
              onClick={() => handleModalShow()}
                onKeyDown={(e) => e.stopPropagation()}
              >
                <div onKeyDown={(e) => e.stopPropagation()}>
                  <AddAssetCompany 
                    showAddSiteAssetModal={showAddSiteAssetModal}
                    handleModalShow={handleModalShow}
                    handleModalClose={handleModalClose}
                  />
                </div>
              </Dropdown.Item>

              {/* Nested dropdown item */}
              <Dropdown className="asset-dropdown-menu" drop={width < 600 ? 'down' : 'right'}>
                <Dropdown.Toggle
                  as="div"
                  className="dropdown-item d-flex justify-content-between align-items-center"
                  style={{ cursor: 'pointer' }}
                >
                  <span>
                    <Icon className="fas fa-file-import mr-2 dropdown-icon" title="Import New" />
                    Import New Assets
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => { 
                      setShowImportModal(true); 
                      setImportIsUpdate(false); 
                      setImportIsCategory(false);
                    }}
                  >
                    <span><Icon className="fas fa-file mr-2 dropdown-icon" />Index Import</span>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => { 
                      setShowImportModal(true); 
                      setImportIsUpdate(false); 
                      setImportIsCategory(true);
                    }}
                  >
                    <span><Icon className="fas fa-box mr-2 dropdown-icon" />Category Import</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* <Dropdown.Item
                data-intercom-target={"import-assets-button"}
                variant="primary"
                className="mr-2 dropdown-label"
                onClick={() => {
                  setShowImportModal(true)
                  setImportIsUpdate(true);
                }}
              >
                <span><Icon className="fas fa-edit mr-2 dropdown-icon" title="Update Existing" />Update Existing Assets</span>
              </Dropdown.Item> */}

              <Dropdown className="asset-dropdown-menu" drop={width < 600 ? 'down' : 'right'}>
                <Dropdown.Toggle
                  as="div"
                  className="dropdown-item d-flex justify-content-between align-items-center"
                  style={{ cursor: 'pointer' }}
                >
                  <span><Icon className="fas fa-edit mr-2 dropdown-icon" title="Update Existing" />Update Existing Assets</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => { 
                      setShowImportModal(true)
                      setImportIsUpdate(true);
                      setImportIsCategory(false);
                    }}
                  >
                    <span><Icon className="fas fa-file mr-2 dropdown-icon" />Index Update</span>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => { 
                      setShowImportModal(true)
                      setImportIsUpdate(true);
                      setImportIsCategory(true);
                    }}
                  >
                    <span><Icon className="fas fa-box mr-2 dropdown-icon" />Category Update</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

            </DropdownButton>
          </div>
          
          {/* Export */}
          <div>
            <CustomProgressBar show={showExportStatus} styling='mb-1' />
            <DropdownButton title="Export" className="mr-1 dropdown-label">
              <DropdownItem
                key="export-all"
                filterExport={false}
                filtersActive={filtersActive}
                totalAssetsUnfiltered={totalAssetsUnfiltered}
                handleExport={handleExport}
              />
              <DropdownItem
                key="export-filtered"
                filterExport={true}
                filtersActive={filtersActive}
                totalAssets={totalAssets}
                handleExport={handleExport}
              />
              <Dropdown.Item onClick={(() => setShowExportModal(true))} >
                <Icon className='fas fa-box mr-1 dropdown-icon'/>
                <span>Export Category</span>
              </Dropdown.Item>
            </DropdownButton>
          </div>

          <div>
            <CustomProgressBar show={showDeleteStatus} styling='mb-1' />
            <Button className="mr-1" onClick={() => setShowDeleteModal(true)}>
              Delete
            </Button>
          </div>

        </div>

        <BulkImportAssets
          showImportModal={showImportModal} 
          setShowImportModal={setShowImportModal}
          importIsUpdate={importIsUpdate}
          importIsCategory={importIsCategory}
          categoriesList={categoriesList}
          setCategoriesList={setCategoriesList}
          categoriesListMemo={categoriesListMemo}
          loadingCategories={loadingCategories}
          companyId={companyId}
          categoryId={categoryId}
          setCategoryId={setCategoryId}
          setShowImportStatus={setShowImportStatus}
          submittingToast={submittingToast}
        />
        
        <BulkDeleteAssets
          showDeleteModal={showDeleteModal} 
          setShowDeleteModal={setShowDeleteModal}
          companyId={companyId}
          setShowDeleteStatus={setShowDeleteStatus}
          submittingToast={submittingToast}
        />

        <ExportCategory
          key="export-category"
          showExportModal={showExportModal}
          setShowExportModal={setShowExportModal}
          handleExport={handleExport}
          categoriesList={categoriesList}
          setCategoriesList={setCategoriesList}
          categoriesListMemo={categoriesListMemo}
          loadingCategories={loadingCategories}
          companyId={companyId}
          setCategoryId={setCategoryId}
        />

        {companyId &&
          <CheckboxTableManual
            columns={[
              {
                key: "ID",
                Header: "Id",
                id: "id",
                width: 60,
                show: false,
                accessor: data => data.id,
              },
              ...columns,
            ]}
            data={rowData}
            noDataText={loadingMsg}
            loadDataAction={loadCompanyAssetsStart}
            loadDataParams={{
              companyId: companyId,
              filters: tableFilters,
            }}
            handler={getDataTableState}
            pages={pagination && pagination.pageCount}
            defaultPageSize={100}
            filterable
            filtered={tableFilters}
            // sortable={sudoSites.length > 0}
            sortable={false}
            keyField="id" // key for the checkbox selections
            className="-striped -highlight"
            allowSelectAll={true}
            // toggleSelection={toggleSelection}              // for the checkbox functionality, EITHER pass a custom toggleSelection function,
            // isSelected={isSelected}                        // and a custom isSelected function,
            selection={selection}                                                       // OR pass a selection array,
            setSelection={(selection) => setSelection([...selection])}  // and a setter for the array.
            selectAll={selectAll}                             // for the select all functionality, pass a selectAll flag (show whether select all is checked or not),
            toggleAll={toggleAll}                        // and EITHER pass a custom toggleAll function
            // setSelectAll={(selectAll) => setSelectAll(!selectAll)}    // OR pass a setter for the flag
            loadingData={loadingCompanyAssets}
            getTdProps={() => ({
              className: 'hide-scrollbar',
            })}
          />
        }

          {selectedCount > 0 && (
            <ActionBar
              serverSideSelectAll={selectAll}
              selection={selection}
              totalCount={pagination?.count}
              deselect={deselect}
            >
              {/* Update Fields */}
              <UpdateFields
                showAssetFieldModal={showAssetFieldModal}
                setShowAssetFieldModal={setShowAssetFieldModal}
                selectAll={selectAll}
                selection={selection}
                setSelectAll={setSelectAll}
                setSelection={setSelection}
                selectedCount={selectedCount}
                companyId={companyId}
                companyAssetsFields={companyAssetsFields}
                checkboxPagination={checkboxPagination}
                loadCompanyAssetsStart={loadCompanyAssetsStart}
                tableFilters={tableFilters}
                totalAssets={selectedCount}
              />
              {/* Duplicate Assets */}
              <DuplicateAssets 
                showDuplicateAssetModal={showDuplicateAssetModal}
                setShowDuplicateAssetModal={setShowDuplicateAssetModal}
                companyId={companyId}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                selection={selection}
                setSelection={setSelection}
                selectedCount={selectedCount}
                checkboxPagination={checkboxPagination}
                loadCompanyAssetsStart={loadCompanyAssetsStart}
                tableFilters={tableFilters}
                triggerDispatch={triggerDispatch}
              />
            </ActionBar> 
          )}

        {/* <ButterToast position={{ vertical: POS_BOTTOM,  horizontal: POS_RIGHT }} /> */}
        <ButterToast position={{ vertical: POS_BOTTOM,  horizontal: POS_RIGHT }} />

        </Card>
      
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    companyId: getCompanyIdFromRoute(state, props),
    pagination: state.serviceDesk.assets.company.data.pagination,
    companyAssetData: state.serviceDesk.assets.company.data,
    loadingCompanyAssets: state.serviceDesk.assets.company.loadingCompanyAssets,
  };
};

export default connect(mapStateToProps)(CompanyAssetsPage)
